import { isEmpty, map } from 'lodash'
import { File } from '../../../api'
import { FileComponentLegacy } from './FileComponentLegacy'

export const FileList = ({ files, field }: { files: File[] | null | undefined; field: string }) => {
  return isEmpty(files) ? (
    <p>There is nothing attached</p>
  ) : (
    <>
      {map(files, (file, index) => (
        <FileComponentLegacy
          key={`${field}-${index}`}
          file={file}
          index={index}
          field={field}
        />
      ))}
    </>
  )
}
